import {useDispatch} from 'react-redux';
import {useTypedSelector} from '../../../hooks/useTypeSelector';
import {FlyerEditorLeftMenu} from './leftMenu/FlyerEditorLeftMenu'
import {FlyerEditorContent} from './rightContent/FlyerEditorContent'
import './FlyerPromosEditor.scss'
import {
    getEmptyFileForPromosAndItemsData, getExcelFileWithCurrentDataForPromosAndItemsData,
    getFlippingFlyer, saveImagesDataForItems, saveImagesDataForPromotions, saveImagesDataForPromotionsItems,
    savePagePromosAndItemsData,
} from '../../../store/actionCreators/flippingFlyerActionCreators';
import React, {useEffect, useState} from "react";
import {ActionType} from "../../../store/actionTypes";
import {setSelectedPageForTabs} from "../../../store/actionCreators/pagesActionCreators";
import {
    addEventDataTypeListener, dispatchEventDataType,
    EVENT_DATA_TYPE_OPEN_PAGES_FLYER, EVENT_DATA_TYPE_UPLOAD_FILE_TYPE,
    removeEventTypeListener
} from "../../../globals/EventDispatcher";
import {CustomDataEvent} from "../../../globals/CustomDataEvent";
import {clearFlyersData} from "../../../store/actionCreators/flyersActionCreators";
import styles from './FlyerPromosEditor.module.scss'
import {PageSpinner} from "../../com/pagesTab/pagesSpinner/spinner";
import {FlyerPageSpotDto, PopupSettings, PromoDto, PromoItemsDto, SelectPageForTabsDto, UserDto} from "../../../dtos";
import {DragDropContext, DragStart} from "react-beautiful-dnd";
import {
    addItemsForUnlinkedPromotionsItemsMenu, addItemsToPromosItemsState,
    addPromosForUnlinkedPromotionsMenu, attachItemsToFlyer, attachItemsToPromo,
    attachPromoToFlyer, attachPromoToFrame, changeActiveUnlinkTab, changeDraggingItemRecId,
    changeSearchTermForUnlinkedPromotionsItems,
    deleteItemsFromUnlinkedPromotionsItemsMenu,
    deletePromosFromUnlinkedPromotionsMenu, removeItemsFromPromosAndAddToFlyerState, toggleUnlinkPromotionsItemsPanel
} from "../../../store/actionCreators/promotionsItemsCreators";
import _ from 'lodash';
import StatusPopup, {StatusPopupType} from "../../../com/statusPopup/StatusPopup";
import {getSettingsForPopup} from "../pages/getSetttingsForPopup";
import {
    UploadPromosItemsExcelOptionsPopup
} from "../uploadPromosItemsExcelOptionsPopup/uploadPromosItemsExcelOptionsPopup";

export const FlyerPromosEditor = () => {
    let flippingFlyerState = useTypedSelector((state) => state.flippingFlyer);
    let flayerDetailsState = useTypedSelector((state) => state.flyerDetails);
    let selectedPageState = useTypedSelector<SelectPageForTabsDto>((state) => state.selectPageForTabs);
    const flyersState = useTypedSelector((state) => state.flyers);
    const framesState = useTypedSelector((state) => state.spots);
    const promotionsItemsState = useTypedSelector((state) => state.promotionsAndItems);
    const dispatch = useDispatch();
    const [isLoading, setLoading] = useState<boolean>(false);
    const [isModalPopup, setModalPopup] = useState<boolean>(false);
    const [popupSettings, setPopupSettings] = useState<PopupSettings>({})
    const [isOpenPagesTab, openPagesTab] = useState<boolean>(false);
    const [selectedItemInMenu, setSelectedItemInMenu] = useState<{ files?: any[], code?: string }>({});
    let [frames, setFrames] = useState<FlyerPageSpotDto[]>([]);
    const [targetPromos, setTargetPromos] = useState<PromoDto[]>([]);
    const [targetUnlinkedPromos, setTargetUnlinkedPromos] = useState<PromoDto[]>([]);
    const [targetItems, setTargetItems] = useState<PromoItemsDto[]>([]);
    const [isDragStart, setDragStatus] = useState<boolean>(false);
    const [isOpenPopupForUploadPromosItemsExcel, setOpenPopupForUploadPromosItemsExcel] = useState<boolean>(false);
    const [sourceIdAndDestinationIds, setSourceIdAndDestinationIds] = useState<{
        sourceId: string,
        destinationId: string,
        sourceIndex: string
        destinationIndex: string
    }>({sourceId: '', destinationId: '', sourceIndex: '', destinationIndex: ''});
    useEffect(() => {
        let sortedArray = frames.sort(compare);
        setFrames(sortedArray);
    }, [frames])

    useEffect(() => {
        if(framesState.warnings && framesState.warnings.length){
            let modalName: string = 'qualificationForFrameWithWarning';

            setPopupSettings({
                    typeStatus: 0,
                    title: '',
                    subTitle: '',
                    messages: framesState.warnings,
                    modalName: modalName,
                }
            )
            setModalPopup(true);
        }
    }, [framesState.warnings]);


    useEffect(() => {
        setFrames(flayerDetailsState.flyerPages[selectedPageState.pageNo === 0 ? 0 : selectedPageState.pageNo - 1]?.flyerPageSpots!);
    }, [selectedPageState, flayerDetailsState]);


    useEffect(() => {
        dispatch(addPromosForUnlinkedPromotionsMenu(flayerDetailsState.flyerPromos?.length ? flayerDetailsState.flyerPromos : [], true));
        dispatch(addItemsForUnlinkedPromotionsItemsMenu(flayerDetailsState.flyerPromoItems?.length ? flayerDetailsState.flyerPromoItems : [], true));
    }, [flayerDetailsState])

    useEffect(() => {
        if (flayerDetailsState.flyLacRec?.lacCode) {
            document.documentElement.style
                .setProperty('--promotions-items-theme-font', flayerDetailsState.flyLacRec?.lacCode === "he-IL" ? 'arial' : 'roboto');

            // document.getElementsByTagName('body')[0].classList.add(flyersBranch.data?.font.toLowerCase());
        }
    }, [flayerDetailsState.flyLacRec?.lacCode])

    useEffect(() => {
        setLoading(flippingFlyerState.loading);
    }, [flippingFlyerState.loading])

    useEffect(() => {
        if (flyersState.type === ActionType.CHANGE_FLYERS_STATE) {
            if (isOpenPagesTab) {
                try {
                    const data = {
                        pageNo: 0,
                        selectedTabNum: 1
                    }
                    dispatch(setSelectedPageForTabs(data));
                } catch (e) {

                }
            }
        }
    }, [flyersState]);

    useEffect(() => {
        addEventDataTypeListener(EVENT_DATA_TYPE_OPEN_PAGES_FLYER, (data: CustomDataEvent) => {
            openPagesTab(data.data);
        })

        addEventDataTypeListener(EVENT_DATA_TYPE_UPLOAD_FILE_TYPE, (data: CustomDataEvent) => {
            setSelectedItemInMenu({
                files: data.data.files,
                code: data.data.code
            });
        })
        console.log('addPromosForUnlinkedPromotionsMenu');

        return () => {
            let userDtoStr = localStorage.getItem("userDto");
            let userDto: UserDto = JSON.parse(userDtoStr!);
            // dispatch(clearDataForUnlinkedPromotionsItemsMenu());
            if (flayerDetailsState.flyRecId !== 0 && userDto) {
                dispatch(getFlippingFlyer(flayerDetailsState.flyRecId))
                dispatch(clearFlyersData());
                dispatch(changeSearchTermForUnlinkedPromotionsItems({
                    searchTermForUnlinkedItems: '',
                    searchTermForUnlinkedPromotions: ''
                }))
                removeEventTypeListener(EVENT_DATA_TYPE_OPEN_PAGES_FLYER);
                removeEventTypeListener(EVENT_DATA_TYPE_UPLOAD_FILE_TYPE);
            }
        }

    }, []);

    useEffect(() => {
        let flyerDto = flayerDetailsState!;
        switch (selectedItemInMenu.code) {
            // case 'UploadPromosFile':
            //     dispatch(savePagePromosData(flyerDto.flyRecId!, selectedItemInMenu.file, flyerDto.flyLacRec!.lacCode!));
            //     break;
            // case 'UploadItemsFile':
            //     dispatch(savePagePromoItemsData(flyerDto.flyRecId!, selectedItemInMenu.file, flyerDto.flyLacRec!.lacCode!));
            //     break;
            case 'UploadPromosAndItemsFile':
                setOpenPopupForUploadPromosItemsExcel(true);
                break;
            case 'UploadItemsImagesFiles':
                dispatch(saveImagesDataForPromotionsItems(flyerDto.flyRecId!, selectedItemInMenu.files ? selectedItemInMenu.files[0] : {}, flyerDto.flyLacRec!.lacCode!))
                break;
            case 'UploadPromoImages':
                dispatch(saveImagesDataForPromotions(flyerDto.flyRecId!, selectedItemInMenu.files ? selectedItemInMenu.files : [], flyerDto.flyLacRec!.lacCode!))
                break;
            case 'UploadItemImages':
                dispatch(saveImagesDataForItems(flyerDto.flyRecId!, selectedItemInMenu.files ? selectedItemInMenu.files : [], flyerDto.flyLacRec!.lacCode!))
                break;
            case 'DownloadEmptyExcelFile':
                dispatch(getEmptyFileForPromosAndItemsData(flyerDto.flyLacRec!.lacCode!));
                break;
            case 'ExportPromosItemsToExcel':
                dispatch(getExcelFileWithCurrentDataForPromosAndItemsData(flyerDto.flyRecId!, flyerDto.flyCaption!));
                break;
        }

    }, [selectedItemInMenu]);

    useEffect(() => {
        try {
            if (promotionsItemsState.type.indexOf('POST_IMAGE_TO_ITEM') === -1 &&
                promotionsItemsState.type.indexOf('DELETE_IMAGE_FROM_ITEM') === -1 &&
                promotionsItemsState.type.indexOf('UPDATE_PROMOTION') === -1 &&
                promotionsItemsState.type.indexOf('CREATE_PROMOTION') === -1
            ) {
                setLoading(promotionsItemsState.isLoading);
                // if(
                //     promotionsItemsState.type === 'ATTACH_PROMO_TO_FLYER_DND_SUCCESS' ||
                //     promotionsItemsState.type === 'ATTACH_PROMO_TO_FRAME_DND_SUCCESS' ||
                //     promotionsItemsState.type === 'ATTACH_PROMO_TO_FLYER_SUCCESS' ||
                //     promotionsItemsState.type === 'ATTACH_PROMO_TO_FRAME_SUCCESS' ||
                //     promotionsItemsState.type === 'DELETE_PROMO_WITH_ITEMS_FROM_FLYER_SUCCESS' ||
                //     promotionsItemsState.type === 'DELETE_PROMO_FROM_FLYER_SUCCESS' ||
                //     promotionsItemsState.type === 'DELETE_ITEMS_FROM_FLYER_SUCCESS' ||
                //     promotionsItemsState.type === 'ATTACH_ITEMS_TO_FLYER_SUCCESS' ||
                //     promotionsItemsState.type === 'ATTACH_ITEM_TO_PROMO_SUCCESS'
                //
                // ){
                //     dispatch(getFlippingFlyer(flayerDetailsState.flyRecId));
                // }
                if (promotionsItemsState.type === 'ATTACH_PROMO_TO_FLYER_DND_SUCCESS') {
                    //save in redux
                    dispatch(addPromosForUnlinkedPromotionsMenu(targetPromos));
                    const newState = [...frames].map(frame => {
                        if (frame.fpsRecId === Number(sourceIdAndDestinationIds.sourceId)) {
                            if (sourceIdAndDestinationIds.destinationId === "unlink_promotions_area") {
                                frame.flyerPromos = [];
                                frame.qualificationLevel = 0;
                            } else {
                                frame.flyerPromos![0].flyerPromoItems = [];
                                frame.qualificationLevel = 0;
                            }
                        }
                        return frame;
                    });
                    //change frames state
                    setFrames(newState);
                } else if (promotionsItemsState.type === 'ATTACH_PROMO_TO_FRAME_DND_SUCCESS') {
                    if (sourceIdAndDestinationIds.sourceId === "unlink_promotions_area") {
                        let newStatePromosForUnlinkMenu = promotionsItemsState.unlinkPromos.filter((unlinkPromo: PromoDto) => unlinkPromo.flrRecId !== Number(sourceIdAndDestinationIds.sourceIndex));
                        let isSelectPromoHasLength = [...frames].some((frame: FlyerPageSpotDto) => frame.fpsRecId === Number(sourceIdAndDestinationIds.destinationId) && frame.flyerPromos?.length !== 0);
                        if (!isSelectPromoHasLength) {
                            dispatch(deletePromosFromUnlinkedPromotionsMenu(newStatePromosForUnlinkMenu));
                        }

                        let newStateFrames = [...frames].map((frame: FlyerPageSpotDto) => {
                            if (frame.fpsRecId === Number(sourceIdAndDestinationIds.destinationId) && frame.flyerPromos?.length === 0) {
                                const targetPromosStateForChange = [...targetPromos];
                                frame.flyerPromos = targetPromosStateForChange.map((promo: PromoDto) => {
                                    promo.flrFpsRecId = frame.fpsRecId;
                                    frame.qualificationLevel = promo.qualificationLevel
                                    return promo;
                                });
                            }
                            return frame;
                        })
                        setFrames(newStateFrames);
                    } else {
                        let sourcePromo: PromoDto[] = [...frames].find(frame => frame.fpsRecId === Number(sourceIdAndDestinationIds.sourceId))?.flyerPromos!;
                        let destinationPromo: PromoDto[] = [...frames].find(frame => frame.fpsRecId === Number(sourceIdAndDestinationIds.destinationId))?.flyerPromos!;

                        //prepare new state for changing
                        //switch in old and current frames promos array
                        const newState = [...frames].map(frame => {
                            if (frame.fpsRecId === Number(sourceIdAndDestinationIds.sourceId)) {
                                frame.flyerPromos = destinationPromo;
                            } else if (frame.fpsRecId === Number(sourceIdAndDestinationIds.destinationId)) {
                                frame.flyerPromos = sourcePromo;
                            }
                            return frame;
                        });
                        //set new frames state
                        setFrames(newState);
                    }
                } else if (promotionsItemsState.type === 'ATTACH_PROMO_TO_FLYER_SUCCESS') {
                    dispatch(addPromosForUnlinkedPromotionsMenu(targetPromos));
                    const newState = [...frames].map(frame => {
                        if (frame.flyerPromos?.length) {
                            const selectedPromo = targetPromos.find((promo: PromoDto) => promo.flrRecId === frame.flyerPromos![0].flrRecId);
                            if (frame.flyerPromos?.length && selectedPromo) {
                                if (frame.flyerPromos![0].flrRecId === selectedPromo.flrRecId!) {
                                    frame.flyerPromos = [];
                                    frame.qualificationLevel = 0;
                                }
                            }
                        }
                        return frame;
                    });
                    //change frames state
                    setFrames(newState);
                    dispatch(toggleUnlinkPromotionsItemsPanel(true));
                    dispatch(changeActiveUnlinkTab("Promotions"));
                } else if (promotionsItemsState.type && promotionsItemsState.type.indexOf('ERROR') > -1) {


                } else if (promotionsItemsState.type === 'ATTACH_PROMO_TO_FRAME_SUCCESS') {
                    const firstEmptyFrames = frames.find((frame: FlyerPageSpotDto) => frame.flyerPromos?.length === 0);
                    let newStatePromosForUnlinkMenu = promotionsItemsState.unlinkPromos.filter((unlinkPromo: PromoDto) => {
                        const selectedRecId = promotionsItemsState.fromUnlinkMenu ? targetUnlinkedPromos[0].flrRecId : targetPromos[0].flrRecId;
                        if (unlinkPromo.flrRecId !== selectedRecId) {
                            return unlinkPromo;
                        }
                    });
                    dispatch(deletePromosFromUnlinkedPromotionsMenu(newStatePromosForUnlinkMenu));
                    const newState = [...frames].map(frame => {
                        if (firstEmptyFrames) {
                            if (frame.fpsRecId === firstEmptyFrames!.fpsRecId) {
                                frame.flyerPromos = promotionsItemsState.fromUnlinkMenu ? targetUnlinkedPromos : targetPromos;
                                frame.qualificationLevel = promotionsItemsState.fromUnlinkMenu ? targetUnlinkedPromos[0].qualificationLevel : targetPromos[0].qualificationLevel
                            }
                        }
                        return frame;
                    });
                    //change frames state
                    setFrames(newState);
                } else if (promotionsItemsState.type === 'DELETE_PROMO_WITH_ITEMS_FROM_FLYER_SUCCESS' || promotionsItemsState.type === 'DELETE_PROMO_FROM_FLYER_SUCCESS') {
                    let newStateForUnlinkPromos: PromoDto[] = promotionsItemsState.unlinkPromos.filter((unlinkedPromo: PromoDto) => {
                        let targetPromoWhichShouldBeDelete = targetUnlinkedPromos.find((promo: PromoDto) => unlinkedPromo.flrRecId === promo.flrRecId);
                        if (!targetPromoWhichShouldBeDelete) {
                            return unlinkedPromo;
                        }
                    });
                    dispatch(deletePromosFromUnlinkedPromotionsMenu(newStateForUnlinkPromos));
                    if (promotionsItemsState.type === 'DELETE_PROMO_FROM_FLYER_SUCCESS') {
                        const unlinkedItemsWhichNeedToAdd: PromoItemsDto[] = [];
                        targetUnlinkedPromos.forEach((promo: PromoDto) => {
                            promo.flyerPromoItems?.forEach((item: PromoItemsDto) => {
                                unlinkedItemsWhichNeedToAdd.push(item);
                            })
                        })
                        dispatch(addItemsForUnlinkedPromotionsItemsMenu(unlinkedItemsWhichNeedToAdd));
                    }
                    setTargetUnlinkedPromos([]);
                } else if (promotionsItemsState.type === 'DELETE_ITEMS_FROM_FLYER_SUCCESS') {
                    let newStateForUnlinkItems: PromoItemsDto[] = promotionsItemsState.unlinkItems.filter((unlinkedItem: PromoItemsDto) => {
                        let targetItemWhichShouldBeDelete = targetItems.find((item: PromoItemsDto) => unlinkedItem.fpiRecId === item.fpiRecId);
                        if (!targetItemWhichShouldBeDelete) {
                            return unlinkedItem;
                        }
                    });
                    dispatch(deleteItemsFromUnlinkedPromotionsItemsMenu(newStateForUnlinkItems));
                } else if (promotionsItemsState.type === 'ATTACH_ITEMS_TO_FLYER_SUCCESS') {
                    if (promotionsItemsState.targetFrameId) {
                        const itemsWhichShouldBeUnlinkFromTargetPromo = promotionsItemsState.targetPromo.flyerPromoItems.filter((promoItem: PromoItemsDto) => {
                            const isIterableItemShouldBeUnlink = promotionsItemsState.itemsIds.find((id: number) => id === promoItem.fpiRecId);
                            if (isIterableItemShouldBeUnlink) {
                                return promoItem;
                            }
                        })
                        dispatch(addItemsForUnlinkedPromotionsItemsMenu(itemsWhichShouldBeUnlinkFromTargetPromo));
                        const newState = [...frames].map(frame => {
                            if (frame.fpsRecId === promotionsItemsState.targetFrameId) {
                                const unlinkItemsArray: PromoItemsDto[] = [];
                                frame.flyerPromos![0].flyerPromoItems = [...frame.flyerPromos![0].flyerPromoItems!].filter((item: PromoItemsDto) => {
                                    const isIterableItemShouldBeUnlink = promotionsItemsState.itemsIds.find((id: number) => id === item.fpiRecId);
                                    if (!isIterableItemShouldBeUnlink) {
                                        return item;
                                    } else {
                                        unlinkItemsArray.push(item);
                                    }
                                });
                                if(!frame.flyerPromos![0].flyerPromoItems.length){
                                    frame.flyerPromos![0].qualificationLevel = 0;
                                    frame.qualificationLevel = 0;
                                } else {
                                    const someItemsNotQualified = frame.flyerPromos![0].flyerPromoItems.some((item: PromoItemsDto) => item.qualificationLevel === 0);
                                    const everyItemsUserQualified = frame.flyerPromos![0].flyerPromoItems.every((item: PromoItemsDto) => item.qualificationLevel === 2);
                                    if(someItemsNotQualified){
                                        frame.flyerPromos![0].qualificationLevel = 0;
                                        frame.qualificationLevel = 0;
                                    } else if(everyItemsUserQualified) {
                                        frame.flyerPromos![0].qualificationLevel = 1;
                                        frame.qualificationLevel = 1;
                                    } else {
                                        frame.flyerPromos![0].qualificationLevel = 1;
                                        frame.qualificationLevel = 1;
                                    }
                                }
                                dispatch(removeItemsFromPromosAndAddToFlyerState(unlinkItemsArray, selectedPageState.pageNo))
                            }
                            return frame;
                        });
                        //change frames state
                        setFrames(newState);
                        dispatch(toggleUnlinkPromotionsItemsPanel(true));
                        dispatch(changeActiveUnlinkTab("Items"));
                    }
                } else if (promotionsItemsState.type === 'ATTACH_ITEM_TO_PROMO_SUCCESS') {
                    setTargetItems([]);
                    console.log(targetItems);
                    let targetItemsWhichShouldToAdd: PromoItemsDto[] = []
                    if (targetItems.length > 1) {
                        targetItemsWhichShouldToAdd = targetItems;
                    } else {
                        targetItemsWhichShouldToAdd = [...promotionsItemsState.unlinkItems].filter((unlinkItem: PromoItemsDto) => unlinkItem.fpiRecId === Number(sourceIdAndDestinationIds.sourceIndex));
                    }

                    const newStateItemsForUnlinkMenu = [...promotionsItemsState.unlinkItems].filter((unlinkItem: PromoItemsDto) => {
                        const targetItemsWhichShouldToAddInUnlinkItems = targetItemsWhichShouldToAdd.find((item: PromoItemsDto) => unlinkItem.fpiRecId === item.fpiRecId);
                        if (!targetItemsWhichShouldToAddInUnlinkItems) {
                            return unlinkItem;
                        }
                    });
                    let isSelectPromoHasLength = [...frames].some((frame: FlyerPageSpotDto) => frame.fpsRecId === Number(sourceIdAndDestinationIds.destinationId) && frame.flyerPromos?.length !== 0);
                    if (isSelectPromoHasLength) {
                        dispatch(deleteItemsFromUnlinkedPromotionsItemsMenu(newStateItemsForUnlinkMenu));
                        let newStateFrames = [...frames].map((frame: FlyerPageSpotDto) => {
                            if (frame.fpsRecId === Number(sourceIdAndDestinationIds.destinationId) && frame.flyerPromos?.length !== 0) {
                                //changed flrRecId to current promoRecId and remove flyRecId because already add to promo
                                const changedTargetItems = targetItemsWhichShouldToAdd.map((item: PromoItemsDto) => {
                                    item.fpiFlyRecId = null;
                                    item.fpiFlrRecId = frame.flyerPromos![0].flrRecId
                                    return item;
                                })
                                dispatch(addItemsToPromosItemsState(changedTargetItems, selectedPageState.pageNo))
                                frame.flyerPromos![0].flyerPromoItems = [...frame.flyerPromos![0].flyerPromoItems!, ...changedTargetItems];
                                if(!frame.flyerPromos![0].flyerPromoItems.length){
                                    frame.flyerPromos![0].qualificationLevel = 0
                                } else {
                                    const someItemsNotQualified = frame.flyerPromos![0].flyerPromoItems.some((item: PromoItemsDto) => item.qualificationLevel === 0);
                                    const everyItemsUserQualified = frame.flyerPromos![0].flyerPromoItems.every((item: PromoItemsDto) => item.qualificationLevel === 2);
                                    if(someItemsNotQualified){
                                        frame.flyerPromos![0].qualificationLevel = 0;
                                        frame.qualificationLevel = 0;
                                    } else if(everyItemsUserQualified) {
                                        frame.flyerPromos![0].qualificationLevel = 1;
                                        frame.qualificationLevel = 1;
                                    } else {
                                        frame.flyerPromos![0].qualificationLevel = 1;
                                        frame.qualificationLevel = 1;
                                    }
                                }
                            }
                            return frame;

                        })
                        setFrames(newStateFrames);
                    }
                }
            }
        } catch (error) {
            console.log(error)
        }
    }, [promotionsItemsState.type])


    const onChangeSelectedItems = (selectedItem: PromoItemsDto, e: React.MouseEvent<HTMLElement>) => {
        const selectedItemState = {...selectedItem};
        const selectedItemsArray = [...targetItems];
        if (e.ctrlKey || e.metaKey) {
            const oldSelectedItems = selectedItemsArray.map((key: PromoItemsDto) => {
                key.isLastSelected = false;
                return key;
            })
            selectedItemState.isLastSelected = true;

            const isSelectedTargetItem = oldSelectedItems.some((item: PromoItemsDto) => item.fpiRecId === selectedItemState.fpiRecId);
            if (isSelectedTargetItem) {
                const newStateForSelectedItems = oldSelectedItems.filter((item: PromoItemsDto) => item.fpiRecId !== selectedItemState.fpiRecId);
                if (newStateForSelectedItems.length) {
                    newStateForSelectedItems[0].isLastSelected = true;
                }
                setTargetItems(newStateForSelectedItems);
            } else {
                setTargetItems([...oldSelectedItems, selectedItemState])
            }
        } else if (e.shiftKey) {
            const isLastSelectedItemExist = selectedItemsArray.some((item: PromoItemsDto) => item.isLastSelected);
            if (isLastSelectedItemExist) {
                const lastSelectedItem = selectedItemsArray.filter((item: PromoItemsDto) => {
                    if (item.isLastSelected) {
                        return item;
                    }
                });
                const isSelectedItemIndexMoreThanLastSelectedIndex = selectedItem!.index! > lastSelectedItem[0].index!;
                if (isSelectedItemIndexMoreThanLastSelectedIndex) {
                    const newStateForSelectedItems = [...promotionsItemsState.unlinkItems].filter((key: PromoItemsDto) => {
                        if (key.index! >= lastSelectedItem[0].index! && key.index! <= selectedItem!.index!) {
                            if (key.index! === lastSelectedItem[0].index!) {
                                key.isLastSelected = true;
                            }
                            return key;
                        }
                    })
                    setTargetItems(newStateForSelectedItems);
                } else {
                    const newStateForSelectedItems = [...promotionsItemsState.unlinkItems].filter((key: PromoItemsDto) => {
                        if (key.index! >= selectedItem!.index! && key.index! <= lastSelectedItem[0].index!) {
                            if (key.index! === lastSelectedItem[0].index!) {
                                key.isLastSelected = true;
                            }
                            return key;
                        }
                    })
                    setTargetItems(newStateForSelectedItems);
                }
            } else {
                selectedItemState.isLastSelected = true;
                setTargetItems([selectedItemState]);
            }
            // const isLastSelectedItemExist
            // promotionsItemsState.unlinkItems
        } else {
            selectedItemState.isLastSelected = true;
            setTargetItems([selectedItemState]);
        }
    }

    const onChangeSelectedPromos = (promo: PromoDto, event: React.MouseEvent<HTMLElement>, index: number) => {
        let unlinkPromotions: PromoDto[] = [];
        [...promotionsItemsState.unlinkPromos].forEach((promo: PromoDto) => {
            const isLastSelectedPromo = targetUnlinkedPromos.find((selectedPromo: PromoDto) => selectedPromo.flrRecId === promo.flrRecId);
            const isLastSelected = isLastSelectedPromo && isLastSelectedPromo.isLastSelected ? isLastSelectedPromo.isLastSelected : false;
            unlinkPromotions.push({
                ...promo,
                isLastSelected: isLastSelected
            });
        });
        if (event.ctrlKey || event.metaKey) {
            const isPromotionAlreadySelected = targetUnlinkedPromos.some((selectedPromo: PromoDto) => selectedPromo.flrRecId === promo.flrRecId);
            if (isPromotionAlreadySelected) {
                const newStateForSelectedPromos = targetUnlinkedPromos.filter((selectedPromo: PromoDto) => selectedPromo.flrRecId !== promo.flrRecId);
                if (newStateForSelectedPromos.length) {
                    newStateForSelectedPromos[0].isLastSelected = true;
                }
                setTargetUnlinkedPromos(newStateForSelectedPromos);
            } else {
                setTargetUnlinkedPromos([...targetUnlinkedPromos, promo])
            }
        } else if (event.shiftKey) {
            const isLastSelectedPromoExist = unlinkPromotions.some((selectedPromo: PromoDto) => selectedPromo.isLastSelected);
            if (isLastSelectedPromoExist) {
                let lastSelectedIndex: number = 0;
                unlinkPromotions.forEach((selectedPromo: PromoDto, index: number) => {
                    if (selectedPromo.isLastSelected) {
                        lastSelectedIndex = index;
                        return selectedPromo;
                    }
                });
                const isSelectedItemIndexMoreThanLastSelectedIndex = index > lastSelectedIndex;
                if (isSelectedItemIndexMoreThanLastSelectedIndex) {
                    const newStateForSelectedPromos = [...unlinkPromotions].filter((promotion: PromoDto, promoIndex: number) => {
                        if (promoIndex >= lastSelectedIndex && promoIndex <= index && !_.isEmpty(promotion)) {
                            return promotion;
                        }
                    });
                    setTargetUnlinkedPromos(newStateForSelectedPromos);
                } else {
                    const newStateForSelectedPromos = [...unlinkPromotions].filter((promotion: PromoItemsDto, promoIndex: number) => {
                        if (promoIndex >= index && promoIndex <= lastSelectedIndex && !_.isEmpty(promotion)) {
                            // if (promoIndex === lastSelectedIndex) {
                            //     promotion.isLastSelected = true;
                            // }
                            return promotion;
                        }
                    })
                    setTargetUnlinkedPromos(newStateForSelectedPromos);
                }
            } else {
                setTargetUnlinkedPromos([{
                    ...promo,
                    isLastSelected: true
                }]);
            }
        } else {
            // const isPromotionAlreadySelected = selectedPromos.some((selectedPromo: PromoDto) => selectedPromo.flrRecId === promo.flrRecId);
            // if(isPromotionAlreadySelected){
            //     setSelectedPromos([]);
            // } else {
            setTargetUnlinkedPromos([{
                ...promo,
                isLastSelected: true
            }]);
            // }
        }
    }

    const compare = (a: any, b: any) => {
        if (Number(a.fpsCode) < Number(b.fpsCode)) {
            return -1;
        }
        if (Number(a.fpsCode) > Number(b.fpsCode)) {
            return 1;
        }
        return 0;
    }


    const onDragStart = (start: DragStart) => {
        const id: number = Number(start.draggableId);
        const dragItem = targetItems.find((item: PromoItemsDto) => item.fpiRecId === Number(id));

        if (!dragItem) {
            setTargetItems([]);
        }
        setTargetUnlinkedPromos([]);

        dispatch(changeDraggingItemRecId(id));
        setDragStatus(true);
    }

    const onDragEnd = (result: any) => {
        dispatch(changeDraggingItemRecId(null));
        setDragStatus(false);
        const {source, destination} = result;
        if (!destination) {
            return;
        }
        setSourceIdAndDestinationIds({
            sourceId: source.droppableId,
            destinationId: destination.droppableId,
            destinationIndex: destination.index,
            sourceIndex: source.index
        });
        console.log(promotionsItemsState);
        // dropped outside the list
        // dropped to the same place

        if (source.droppableId === destination.droppableId) {
            return;
        } else if (source.droppableId === "unlink_promotions_area" || source.droppableId === "unlink_items_area_1" || source.droppableId === "unlink_items_area_2") {
            if (source.droppableId === "unlink_promotions_area") {
                const activePromo: PromoDto[] = promotionsItemsState.unlinkPromos.filter((unlinkPromo: PromoDto) => unlinkPromo.flrRecId === Number(source.index));
                setTargetPromos(activePromo);
                const targetFrame = [...frames].find((frame: FlyerPageSpotDto) => frame.fpsRecId === Number(destination.droppableId) && frame.flyerPromos?.length === 0)
                if (targetFrame) {
                    dispatch(attachPromoToFrame(activePromo[0].flrRecId!, targetFrame.fpsRecId!, true, flayerDetailsState.flyLacRec.lacCode));
                }
            } else {
                let targetItemsIds: number[];
                if (targetItems.length) {
                    targetItemsIds = [...targetItems].map((item: PromoItemsDto) => item.fpiRecId!);
                } else {
                    const activeItem = [...promotionsItemsState.unlinkItems].filter((unlinkItem: PromoItemsDto) => unlinkItem.fpiRecId === Number(source.index));
                    targetItemsIds = [activeItem[0].fpiRecId];
                }
                const targetFrame = [...frames].filter((frame: FlyerPageSpotDto) => {
                    return frame.fpsRecId === Number(destination.droppableId)
                });
                if (targetFrame[0]?.flyerPromos?.length) {
                    dispatch(attachItemsToPromo(Number(targetFrame[0].flyerPromos[0].flrRecId), targetItemsIds));
                }
            }
            // const target
        } else if (destination.droppableId === "unlink_promotions_area" || destination.droppableId === "unlink_items_area_1" || destination.droppableId === "unlink_items_area_2") {
            //find selected promo in frame
            let sourcePromo: PromoDto[] = [...frames].find(frame => frame.fpsRecId === Number(source.droppableId))?.flyerPromos!;
            //clear promo from current frame and create new frames
            setTargetPromos(sourcePromo);
            if (destination.droppableId === "unlink_promotions_area") {
                //request for DB
                dispatch(attachPromoToFlyer(flayerDetailsState.flyRecId, [sourcePromo[0].flrRecId!], true, flayerDetailsState.flyLacRec.lacCode));
            } else {
                if (sourcePromo[0].flyerPromoItems && sourcePromo[0].flyerPromoItems.length > 0) {
                    const itemsIdsWhichShouldUnlink = [...sourcePromo[0].flyerPromoItems].map((item: PromoItemsDto) => item.fpiRecId!);
                    const sourceFrame = [...frames].find((frame: FlyerPageSpotDto) => frame.fpsRecId === Number(source.droppableId));
                    //request for DB
                    dispatch(attachItemsToFlyer(flayerDetailsState.flyRecId, itemsIdsWhichShouldUnlink, true, sourcePromo[0], sourceFrame!.fpsRecId!))
                }
            }

        } else {
            //get promos from old frame and get promos from target frame

            let sourcePromo: PromoDto[] = [...frames].find(frame => frame.fpsRecId === Number(source.droppableId))?.flyerPromos!;
            const targetFrame = [...frames].find((frame: FlyerPageSpotDto) => frame.fpsRecId === Number(destination.droppableId) && frame.flyerPromos?.length === 0)
            setTargetPromos(sourcePromo);
            if (targetFrame) {
                dispatch(attachPromoToFrame(sourcePromo[0].flrRecId!, targetFrame.fpsRecId!, true, flayerDetailsState.flyLacRec.lacCode));
            }
        }
    }

    let settingsForPopup = getSettingsForPopup(popupSettings);

    return (

        <div className="flyer_promos_editor_container">
            <DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart}>
                <FlyerEditorLeftMenu frames={frames} setFrames={setFrames}
                                     setTargetPromos={setTargetPromos}/>
                <FlyerEditorContent
                    data={flayerDetailsState}
                    onChangeSelectedPromos={onChangeSelectedPromos}
                    setTargetUnlinkedPromos={setTargetUnlinkedPromos}
                    onChangeSelectedItems={onChangeSelectedItems}
                    setTargetItems={setTargetItems}
                    targetUnlinkedPromos={targetUnlinkedPromos}
                    targetItems={targetItems}
                    isDragStart={isDragStart}
                />
                {isLoading && <div className={styles.isLoading}>
                    <PageSpinner/>
                </div>}
            </DragDropContext>
            {isModalPopup && <StatusPopup
                settings={settingsForPopup}
                type={settingsForPopup.typeStatus ? settingsForPopup.typeStatus : StatusPopupType.CONFIRM}
                title={settingsForPopup.title ? settingsForPopup.title : 'INFO'}
                subTitle={''}
                messages={settingsForPopup.messages}
                show={isModalPopup}
                handleClose={() => {

                    setModalPopup(false);
                }}
            />}
            <UploadPromosItemsExcelOptionsPopup
                isOpen={isOpenPopupForUploadPromosItemsExcel}
                flyerId={flayerDetailsState.flyRecId}
                file={selectedItemInMenu.files ? selectedItemInMenu.files[0] : null}
                lang={flayerDetailsState.flyLacRec.lacCode}
                onClose={() => {
                    setOpenPopupForUploadPromosItemsExcel(false);
                    const data = {
                        files: [{}],
                        code: ''
                    }
                    dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_UPLOAD_FILE_TYPE, data);

                }}

            />
        </div>
    )
}